"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CctvCenterVideo = exports.Video = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Video = (arg) => {
    let source = '';
    // const livestream = document.getElementById('livestream')
    const ms = new MediaSource();
    const verbose = false;
    const queue = [];
    let streamingStarted = false;
    const url = arg.url;
    const pushPacket = (arr, sourceBuffer) => {
        const view = new Uint8Array(arr);
        if (verbose) {
            console.log('got', arr.byteLength, 'bytes.  Values=', view[0], view[1], view[2], view[3], view[4]);
        }
        const data = arr;
        try {
            if (queue.length > 0 && sourceBuffer.updating && !streamingStarted) {
                sourceBuffer.appendBuffer(data);
                streamingStarted = true;
                return;
            }
            queue.push(data);
            if (verbose) {
                console.log('queue push:', queue.length);
            }
            if (!sourceBuffer.updating) {
                loadPacket(sourceBuffer);
            }
        }
        catch (error) {
        }
    };
    const loadPacket = (sourceBuffer) => {
        if (!sourceBuffer.updating) {
            if (queue.length > 0) {
                const inp = queue.shift();
                if (verbose) {
                    console.log('queue PULL:', queue.length);
                }
                if (inp != undefined) {
                    const view = new Uint8Array(inp);
                    if (verbose) {
                        console.log('writing buffer with', view[0], view[1], view[2], view[3], view[4]);
                    }
                    try {
                        sourceBuffer.appendBuffer(inp);
                        streamingStarted = true;
                    }
                    catch (error) {
                    }
                }
            }
            else {
                streamingStarted = false;
            }
        }
    };
    const playRTC = () => {
        const ws = new WebSocket(url);
        let mimeCodec;
        ws.binaryType = 'arraybuffer';
        ws.onopen = function () {
            console.log('Connect ', url);
        };
        let sourceBuffer;
        ws.onmessage = function (event) {
            const data = new Uint8Array(event.data);
            if (data[0] == 9) {
                const decoded_arr = data.slice(1);
                if (window.TextDecoder) {
                    mimeCodec = new TextDecoder('utf-8').decode(decoded_arr);
                }
                else {
                    mimeCodec = Utf8ArrayToStr(decoded_arr);
                }
                if (verbose) {
                    console.log('first packet with codec data: ' + mimeCodec);
                }
                sourceBuffer = ms.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"');
                sourceBuffer.mode = 'segments';
                sourceBuffer.addEventListener('updateend', () => {
                    loadPacket(sourceBuffer);
                });
            }
            else {
                pushPacket(event.data, sourceBuffer);
            }
        };
    };
    ms.addEventListener('sourceopen', playRTC, false);
    source = window.URL.createObjectURL(ms);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { zIndex: 1 } }, { children: (0, jsx_runtime_1.jsx)("video", { style: { borderRadius: 10 }, width: '100%', id: 'livestream', src: source, autoPlay: true }) })) }));
};
exports.Video = Video;
const Utf8ArrayToStr = (array) => {
    let out, i, c;
    let char2, char3;
    out = '';
    i = 0;
    while (i < array.length) {
        c = array[i++];
        switch (c >> 4) {
            case 7:
                out += String.fromCharCode(c);
                break;
            case 13:
                char2 = array[i++];
                out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
                break;
            case 14:
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
                break;
        }
    }
    return out;
};
const CctvCenterVideo = (arg) => {
    let source = '';
    // const livestream = document.getElementById('livestream')
    const ms = new MediaSource();
    const verbose = false;
    const queue = [];
    let streamingStarted = false;
    const url = arg.url;
    const pushPacket = (arr, sourceBuffer) => {
        const view = new Uint8Array(arr);
        if (verbose) {
            console.log('got', arr.byteLength, 'bytes.  Values=', view[0], view[1], view[2], view[3], view[4]);
        }
        const data = arr;
        try {
            if (queue.length > 0 && sourceBuffer.updating && !streamingStarted) {
                sourceBuffer.appendBuffer(data);
                streamingStarted = true;
                return;
            }
            queue.push(data);
            if (verbose) {
                console.log('queue push:', queue.length);
            }
            if (!sourceBuffer.updating) {
                loadPacket(sourceBuffer);
            }
        }
        catch (error) {
        }
    };
    const loadPacket = (sourceBuffer) => {
        if (!sourceBuffer.updating) {
            if (queue.length > 0) {
                const inp = queue.shift();
                if (verbose) {
                    console.log('queue PULL:', queue.length);
                }
                if (inp != undefined) {
                    const view = new Uint8Array(inp);
                    if (verbose) {
                        console.log('writing buffer with', view[0], view[1], view[2], view[3], view[4]);
                    }
                    try {
                        sourceBuffer.appendBuffer(inp);
                        streamingStarted = true;
                    }
                    catch (error) {
                    }
                }
            }
            else {
                streamingStarted = false;
            }
        }
    };
    const playRTC = () => {
        const ws = new WebSocket(url);
        let mimeCodec;
        ws.binaryType = 'arraybuffer';
        ws.onopen = function () {
            console.log('Connect ', url);
        };
        let sourceBuffer;
        ws.onmessage = function (event) {
            const data = new Uint8Array(event.data);
            if (data[0] == 9) {
                const decoded_arr = data.slice(1);
                if (window.TextDecoder) {
                    mimeCodec = new TextDecoder('utf-8').decode(decoded_arr);
                }
                else {
                    mimeCodec = Utf8ArrayToStr(decoded_arr);
                }
                if (verbose) {
                    console.log('first packet with codec data: ' + mimeCodec);
                }
                sourceBuffer = ms.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"');
                sourceBuffer.mode = 'segments';
                sourceBuffer.addEventListener('updateend', () => {
                    loadPacket(sourceBuffer);
                });
            }
            else {
                pushPacket(event.data, sourceBuffer);
            }
        };
    };
    ms.addEventListener('sourceopen', playRTC, false);
    source = window.URL.createObjectURL(ms);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { zIndex: 1 } }, { children: (0, jsx_runtime_1.jsx)("video", { style: { borderRadius: 10 }, width: '100%', id: 'livestream', src: source, disableRemotePlayback: true, controls: true, autoPlay: true }) })) }));
};
exports.CctvCenterVideo = CctvCenterVideo;
